import React from 'react';
import styled from 'styled-components';
import comestaiLogo from '../assets/logo.png';
import comestaiLogoCe from '../assets/logo-ce.png';
import { useTheme } from 'styled-components';
import { fontSize } from '../style/tokens';
import { footerBg, footerMutedFg } from '../style/header';
import { healthVersion, checkVersion, sdkVersion } from '../../package.json';

const majorMinor = (v: string) => v.split('.').slice(0, 2).join('.');

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 20px 12px;
  /* Partner's colore_footer, else transparent (page background). */
  background: ${footerBg};
`;

const PoweredBy = styled.span`
  font-size: ${fontSize.xs};
  color: ${footerMutedFg('#888')};
  font-family: inherit;
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Img = styled.img`
  height: 46px;
  max-width: 200px;
  object-fit: contain;
  pointer-events: none;
`;

const Version = styled.span`
  font-size: 10px;
  color: ${footerMutedFg('#aaa')};
  font-family: inherit;
  align-self: flex-end;
  padding-bottom: 4px;
`;

// CE build shows two stacked version lines (app + SDK).
const VersionBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: flex-end;
  padding-bottom: 4px;
`;

const VersionLine = styled.span`
  font-size: 10px;
  color: ${footerMutedFg('#aaa')};
  font-family: inherit;
  line-height: 1.3;
`;

const FooterLogo: React.FC = () => {
  const { footerVisible, istanza_ce } = useTheme();
  if (!footerVisible) return null;
  return (
    <Wrapper>
      <PoweredBy>Powered by</PoweredBy>
      <LogoRow>
        <Img src={istanza_ce ? comestaiLogoCe : comestaiLogo} alt="Comestai" />
        {istanza_ce ? (
          <VersionBlock>
            <VersionLine>app V{majorMinor(checkVersion)}</VersionLine>
            <VersionLine>SDK V{majorMinor(sdkVersion)}</VersionLine>
          </VersionBlock>
        ) : (
          <Version>v{majorMinor(healthVersion)}</Version>
        )}
      </LogoRow>
    </Wrapper>
  );
};

export default FooterLogo;
